export class ModalController {
  constructor($scope) {
    'ngInject'; 

    this.$scope = $scope;
  }

  $doCheck() {
    this.modalTitle = this.$scope.modalTitle;
    this.modalContent = this.$scope.modalContent;
  }

  onOkClicked() {
    this.onOk();
  }
}

export default ModalController;



// WEBPACK FOOTER //
// ./client/app/shared/ui/modal/modal.controller.js